import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

const swiper = new Swiper('.HeroSlider', {
    modules: [Navigation, Pagination, EffectFade],
    loop: true,
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    navigation: {
        nextEl: '.HeroSlider__nextBtn',
        prevEl: '.HeroSlider__prevBtn',
    },

    pagination: {
        el: '.HeroSlider__pagination',
        type: 'bullets',
        bulletClass: 'HeroSlider__pagination-item',
        renderBullet: (index, className) => {
            return `<span class="${className}">0${index + 1}</span>`;
        },
    },
    speed: 700,
});
